import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import store from "./redux";
import "./helpers/setResizeEventListener";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import useHandleCache from "./hooks/useHandleCache";
import Loader from "./components/Loader";
import styles from "./index.module.scss";
import ErrorBoundary from "@components/ErrorBoundary";

const Application = () => {
  useHandleCache();

  useEffect(() => {
    // should catch dynamic imports error
    // https://vite.dev/guide/build#load-error-handling
    const clb = () => {
      window.location.reload();
    };
    window.addEventListener("vite:preloadError", clb);
    return () => {
      window.removeEventListener("vite:preloadError", clb);
    };
  }, []);

  return (
    <ErrorBoundary
      fallback={
        <h1 className="text-primary">
          Something went wrong, please reload the page
        </h1>
      }
    >
      <Suspense fallback={<Loader className={styles.loader} />}>
        <Provider store={store}>
          <App isServerInfo />
        </Provider>
      </Suspense>
    </ErrorBoundary>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Application />);

serviceWorkerRegistration.register();
